import { all } from "redux-saga/effects";
import Auth from "./Auth";
import UserManagement from "./UserManagement";
import RoleManagement from "./RoleManagement";

export default function* rootSaga(getState) {
  yield all([Auth(), UserManagement(), RoleManagement()]);
}
